import Vue from 'vue'
// 样式
import 'vant/lib/index.less'
import '@/assets/style/base.less'
import '@/assets/style/reset-component.less'
import 'vant/lib/icon/local.css'
import '@/assets/style/iconfont/iconfont.css'
import './permission'
import App from './App'
import router from './router'
import Cookies from 'js-cookie'
import _ from 'lodash'
import 'lib-flexible/flexible'
import {
  ApiExecute
} from '@utils/tool'
import store from '@/store'
import Vant from 'vant'
import axios from 'axios'
import VeeValidate, {
  Validator
} from 'vee-validate'
import zh_CN from '@utils/form-validate/validate'
import * as filters from './filters'
import globalVariable from '@/Api/global_variable.js'
import Moment from 'moment'
import VueI18n from 'vue-i18n'
import i18n from '@/lang'
import VueQriously from 'vue-qriously'
import Element from 'element-ui'
import animate from 'animate.css'
Vue.use(animate)
// import '@utils/vConsole.js' // 生产环境去掉
Vue.use(VueQriously)
Vue.prototype.$Request = ApiExecute
Vue.config.productionTip = false
Vue.prototype.$moment = Moment
Vue.prototype.GLOBAL = globalVariable // 全局变量

Vue.use(Element)

// 组件引入
Vue.use(Vant)
// Vue.use(VeeValidate);
Vue.use(VeeValidate, {
  fieldsBagName: 'vee-fields',
  locale: 'zh_CN',
  dictionary: {
    zh_CN
  }
})
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
})
Moment.locale('zh-cn')
Vue.use(VueI18n)
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
// 后端让增加的配置chenzhuojie
// if (!Cookies.get('token')) {
  // 等于空 说明没有登陆
  axios.get(`/public.json?t=${new Date().getTime()}`).then(res => {
    if (res.data.length > 0) {
      axios
        .get(
          `https://geteway.smartee.cn/Http/HttpRequest?type=${res.data[0].type}&country=${res.data[0].country}`
        )
        .then(res => {
          localStorage.setItem('BASE_API_1', res.data.BASE_API_1);
          localStorage.setItem('CANVAS_URI', res.data.CANVAS_URI);
          localStorage.setItem('UPLOAD_URI', res.data.UPLOAD_URI);
          localStorage.setItem('VCode', res.data.VCode);
        });
    } else {
      localStorage.removeItem('BASE_API_1');
      localStorage.removeItem('CANVAS_URI');
      localStorage.removeItem('UPLOAD_URI');
      localStorage.removeItem('VCode');
    }
  })
// }
Vue.prototype.$canvalsUrl =
  localStorage.getItem('CANVAS_URI') || process.env.CANVAS_URL
Vue.prototype.$uploadDomain =
  localStorage.getItem('UPLOAD_URI') || process.env.UPLOAD_DOMAIN

Vue.prototype.$isChild = [35, 59, 63]
Vue.prototype.$isEarly = [67, 70, 79]
Vue.prototype.$isSmartGS = [7, 55, 57, 106]
Vue.prototype.$isResetType = [22, 56, 105, 34]
Vue.prototype.$isGs = [...Vue.prototype.$isSmartGS, ...Vue.prototype.$isResetType]
Vue.prototype.$isSixElement = [71, 103]
Vue.prototype.$isBrace = [80]
Vue.prototype.$isSmarteeGSII = [8]
Vue.prototype.$isS17 = [52, 53, 54]
Vue.prototype.$isT0 = [92]

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js